import { organisasjonsformer } from "../konto/organisasjonsformer"
import { mvaRegistrert } from "../konto/mvaRegistrert"

const { as, enk } = organisasjonsformer

export type TagsFuncPropType = Record<"medMva" | "orgForm", string>
export type Tags = { [key: string]: (mva: TagsFuncPropType) => boolean }

export const tags: Tags = {
  mva: ({ medMva }: { medMva: string }): boolean => medMva === mvaRegistrert.medMva,
  as: ({ orgForm }: { orgForm: string }): boolean => orgForm === as.id,
  enk: ({ orgForm }: { orgForm: string }): boolean => orgForm === enk.id,
  forever: (): boolean => false,
  kontohjelper: (): boolean => true,
}

export const tagNames: string[] = Object.keys(tags).flatMap((tag) => [tag, `ikke-${tag}`])
